import React, { useEffect, useState } from "react";
import { HANDLE_ERROR } from "../Redux/action.type";
import { showToast } from "./Toast";
import { useDispatch, useSelector } from "react-redux";
import { placeOrder } from "../Redux/Action/order.action";

const PaymentRazor = ({ data, closeRazorpayPopup, handleClosePopup, razorPayKeyid }) => {
  const dispatch = useDispatch();
  const [isPaymentProcessing, setIsPaymentProcessing] = useState(false);
  const price = Math.round((data?.remaining_price || data?.total_price) * 100);
  useEffect(() => {
    const initializeRazorpay = async () => {
      try {
        const options = {
          key: razorPayKeyid,
          name: "",
          description: "",
          amount: price,
          handler: async function (response) {
            setIsPaymentProcessing(true);
            try {
              let updateCart;
              if (!data?.split_payment) {
                const { cash_amount, ...restOfCart } = data;
                updateCart = {
                  ...restOfCart,
                  transaction_id: response?.razorpay_payment_id,
                  digital_amount: data?.total_price,
                };
              } else {
                updateCart = {
                  ...data,
                  transaction_id: response?.razorpay_payment_id,
                  digital_amount: data?.total_price,
                };
              }
              dispatch(placeOrder(updateCart));
            } catch (error) {
              showToast.error(error);
            } finally {
              setIsPaymentProcessing(false);
              closeRazorpayPopup();
              handleClosePopup();
            }
          },
          modal: {
            ondismiss: async () => {
              handleClosePopup();
              return null;
            },
          },
          prefill: {
            name: data.user?.name || "",
            email: data.user?.email || "",
            contact: data?.customer_phone || "",
          },
          notes: {
            order: data.order_id,
          },
          theme: {
            color: "#1256ff",
          },
        };
        var rzp1 = new window.Razorpay(options);
        rzp1.open();
        rzp1.on(`payment.failed`, async () => {
          try {
            return null;
          } catch (error) {
            showToast.error(error);
          }
        });
      } catch (error) {
        showToast.error(error);
        dispatch({
          type: HANDLE_ERROR,
          payload: error,
        });
      }
    };
    if (!data) {
      return null;
    } else {
      initializeRazorpay();
    }
  }, [data, dispatch, isPaymentProcessing]);
  return <></>;
};

export default PaymentRazor;
